import React from "react";
import PortalTarget from "../PortalTarget/PortalTarget";
import { twMerge } from "tailwind-merge";
import { observer } from "mobx-react-lite";
const Tooltip = ({ content, children, className, contentWrapperClassName, childrenWrapperClassName, offsetX, offsetY, alignment, portalAnchor: _portalAnchor, }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const portalAnchor = _portalAnchor ??
        {
            topLeft: "bottomRight",
            topRight: "bottomLeft",
            bottomLeft: "topRight",
            bottomRight: "topLeft",
            center: "center",
            centerLeft: "centerRight",
            centerRight: "centerLeft",
            topCenter: "bottomCenter",
            bottomCenter: "topCenter",
        }[alignment];
    return (React.createElement(PortalTarget, { className: className, isVisible: isOpen, anchor: alignment, portal: {
            offsetY,
            offsetX,
            considerScreenBoundaries: true,
            onClickOutside: () => setIsOpen(false),
            anchor: portalAnchor,
            render: ({ ref, style }) => (React.createElement(TooltipContent, { onMouseLeave: () => setIsOpen(false), onMouseEnter: () => setIsOpen(true), ref: ref, style: style, className: twMerge(portalAnchor === "bottomLeft" && "rounded-bl-none", portalAnchor === "bottomRight" && "rounded-br-none", portalAnchor === "topRight" && "rounded-tr-none", portalAnchor === "topLeft" && "rounded-tl-none", contentWrapperClassName) }, content)),
        }, renderChild: (ref) => {
            return (React.createElement("button", { ref: ref, className: twMerge("h-fit w-fit cursor-pointer", childrenWrapperClassName), onClick: () => setIsOpen(!isOpen), onMouseLeave: () => setIsOpen(false), onMouseEnter: () => setIsOpen(true) }, children));
        } }));
};
export const TooltipContent = observer(React.forwardRef((props, ref) => {
    return (React.createElement("div", { tabIndex: -1, ref: ref, ...props, className: twMerge("typography-small__t animate-slideTop-fade-in rounded-[10px] border-[1px] border-solid border-separator-color bg-card-color py-3 px-4 text-gray-text-color shadow-big", props.className) }, props.children));
}));
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map